import { body } from '../body'
import { colors } from '../colors'

export const toast = {
  bgColor: colors.white,
  boxShadow: `2px 2px 10px ${body.boxShadowColor}`,
}
